import { Component, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms'; 
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services/index';
import {ToastrService} from 'ngx-toastr';
import { FormGroup, FormControl } from '@angular/forms';



@Component({
  selector: 'app-bsgrouping',
  templateUrl: './bsgrouping.component.html',
  styleUrls: ['./bsgrouping.component.css']
})
export class BsgroupingComponent implements OnInit {
  newAccountForm: FormGroup;
  choosefromdefault = '1';
  public GROUP_TITLE:''
  public GROUP_CATEGORY:''
  GROUP_CATEGORY_ID = '0';
  public currentUser: any;
  public loading = false;
  public filter = { PLDDATE: '', PLDDATE_: '', SHOW_ZERO_BALANCE: false }
  public data: any;
  public group = { GROUP_TITLE: '', GROUP_CATEGORY: '', LENDER_ACCOUNT_ID: [] };
  create_group = false;
  accounts: any;
  accounts_ids: any = [];
  accounts_idss: any = [];
  account_id: any;
  add_item = false;
  group_id: any;
  group_category_id = '';
  no_data = false;
  default_balance_sheet_groups:any;
  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, private toastr: ToastrService ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.newAccountForm = new FormGroup({
      GROUP_TITLE: new FormControl(),
      GROUP_CATEGORY: new FormControl(),
      LENDER_ACCOUNT_ID: new FormControl()
    })
  }


  ngOnInit() {
    // this.getBSGrouping()
    this.listBsGroup();
    this.getAccounts()
  }
  getBSGroupsByCategory(event){
    this.operationsService.getBSGroupsByCategory(this.currentUser.token, this.GROUP_CATEGORY_ID).subscribe(res => {
      this.default_balance_sheet_groups = res.balance_sheet_groups; 
    });
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  showSuccess(msg) {
    return this.toastr.success(msg, 'Success');
  }
  getAccounts() {
    this.operationsService.displayAccounts(this.currentUser.token).subscribe(res => {
      this.accounts = res.all_accounts;
      this.default_balance_sheet_groups = res.balance_sheet_groups;
    });
  }
  listBsGroup() {
    return this.operationsService.listBsGroup(this.currentUser.token).subscribe(res => {
      if (res.status) {
        this.no_data = false;
        this.data = res.bs_groups;
      } else {
        this.no_data = true;
      }
    });
  }
  getBSGrouping() {
    this.operationsService.getBSGrouping(this.currentUser.token)
      .subscribe(data => {
        this.data = data
      });
  }
  createGroup() {
    this.create_group = !this.create_group;
    this.add_item = false;
  }
  addAccount() {
    console.log(this.newAccountForm.value)
    this.accounts_ids.push(this.newAccountForm.controls['LENDER_ACCOUNT_ID'].value.id);
    this.accounts_idss.push(this.newAccountForm.controls['LENDER_ACCOUNT_ID'].value.account_name)
    console.log(this.accounts_idss)
  }
  addBsGroup() {
    this.GROUP_TITLE = this.newAccountForm.controls['GROUP_TITLE'].value
    if (!this.GROUP_TITLE) {
      return this.showError('Group title is required');
    }
    this.GROUP_CATEGORY = this.newAccountForm.controls['GROUP_CATEGORY'].value
    if (!this.GROUP_CATEGORY) {
      return this.showError('Select a category');
    }
    if (!this.accounts_ids) {
      return this.showError('Select an account');
    }
    this.loading = true;
    this.operationsService.addBsGroup(this.currentUser.token, this.GROUP_TITLE, this.GROUP_CATEGORY, this.accounts_ids).subscribe(res => {
      console.log(res);
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.listBsGroup();
        this.GROUP_CATEGORY = '';
        this.GROUP_TITLE = '';
        this.accounts_ids = [];
      } else {
        this.showError(res.response);
        this.loading = false;
      }
    }, err => {
      this.showError('An error occured, try again');
      this.loading = false;
    });
  }
  getCategoryName(category_id) {
    if (category_id == 1) {
      return 'Asset';
    }
    if (category_id == 2) {
      return 'Liability';
    }
    if (category_id == 3) {
      return 'Equity';
    }
    if (category_id == 4) {
      return 'Contingent Liabilities';
    }
  }
  deleteGroup(group_id) {
    this.loading = true;
    this.operationsService.deleteBsGroup(this.currentUser.token, group_id).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.listBsGroup();
      } else {
        this.loading = false;
        this.showError(res.response);
      }
    }, () => {
      this.loading = false;
    });
  }
  addItem(group_id, group_title, group_category_id) {
    console.log(group_category_id,group_id,group_title)
    this.add_item = !this.add_item;
    this.create_group = false;
    this.group_id = group_id;
    this.GROUP_TITLE = group_title;
    this.accounts_ids = []
    this.accounts_idss = []
    this.GROUP_CATEGORY = group_category_id
  }
  updateBsGroup() {
    if (!this.GROUP_TITLE) {
      return this.showError('Group title is required');
    }
    if (!this.GROUP_CATEGORY) {
      return this.showError('Select a category');
    }
    if (!this.accounts_ids) {
      return this.showError('Select an account');
    }
    this.loading = true;
    this.operationsService.updateBsGroup(this.currentUser.token, this.GROUP_TITLE, this.GROUP_CATEGORY, this.accounts_ids, this.group_id).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.response);
        this.listBsGroup();
        this.GROUP_TITLE = "";
        this.GROUP_CATEGORY = "";
        this.accounts_ids = [];
      } else {
        this.showError(res.response);
        this.loading = false;
      }
    }, err => {
      this.loading = false;
    })
  }
  moveGroupUp(group_id, up, group_category_id) {
    this.operationsService.moveBsGroupOrder(this.currentUser.token, group_id, up, false, group_category_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listBsGroup();
      } else {
        this.showError(res.response)
      }
    }, err => {
      this.showError('An error occurred, try again');
    });
  }
  moveGroupDown(group_id, down, group_category_id) {
    this.operationsService.moveBsGroupOrder(this.currentUser.token, group_id, false, down, group_category_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listBsGroup();
      }
    }, () => {
      this.showError('An error occurred, try again');
    });
  }

  moveAccountRight(group_id, right, group_item_id) {
    return this.operationsService.moveBsAccountOrder(this.currentUser.token, group_id, false, right, group_item_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listBsGroup();
      } else {
        this.showError(res.response);
      }
    }, () => this.showError('An error occurred, try again'));
  }
  moveAccountLeft(group_id, left, group_item_id) {
    return this.operationsService.moveBsAccountOrder(this.currentUser.token, group_id, left, false, group_item_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listBsGroup();
      } else {
        this.showError(res.response);
      }
    }, () => this.showError('An error occurred, try again'));
  }
  deleteAccountFromGroup(group_item_id, account_id) {
    return this.operationsService.deleteAccountFromBsGroup(this.currentUser.token, group_item_id, account_id).subscribe(res => {
      if (res.status) {
        this.showSuccess(res.response);
        this.listBsGroup();
      } else {
        this.showError(res.response)
      }
    }, () => {
      this.showError('An error occurred, try again')
    });
  }
  removeAcc(index){
    this.accounts_ids.splice(index)
    this.accounts_idss.splice(index)
  }
}
